import type { ErrorEvent } from '@sentry/browser';

/** Ignore only the extension iframe error observed in WEBSITE-NEXTJS-39. */
export function isAdblockerIframeAccessError(
  event: Pick<ErrorEvent, 'exception' | 'extra'>
): boolean {
  const exceptions = event.exception?.values;
  if (exceptions?.length !== 1) return false;
  const exception = exceptions[0];
  if (
    exception.type !== 'SecurityError' ||
    !exception.value?.includes(
      "Failed to read a named property 'Element' from 'Window'"
    ) ||
    !exception.value.includes('from accessing a cross-origin frame')
  ) {
    return false;
  }

  // Sentry normalizes instrumented callback arguments before beforeSend.
  // Match the load target, not a breadcrumb or merely the presence of an
  // extension: website/demo iframe access errors must still be reported.
  const args = event.extra?.arguments;
  return (
    Array.isArray(args) &&
    args.some(
      arg =>
        arg !== null &&
        typeof arg === 'object' &&
        arg.type === 'load' &&
        typeof arg.target === 'string' &&
        /(?:^|>\s*)iframe(?:[.#][\w-]+)*\.adblocker-popup-info(?:\.[\w-]+)*$/.test(
          arg.target
        )
    )
  );
}
